/**
 * dealers-zip-lookup.js
 * assets/dealers-zip-lookup.js
 * Load BEFORE request-a-quote.js in theme.liquid.
 */

(function (global) {
  'use strict';

  const PLACEHOLDER_ZIP = '99999';

  function normalizeDigitsToZip(input) {
    const d = String(input || '').trim().replace(/\D/g, '');
    if (d.length >= 9) return d.slice(0, 5);
    if (d.length === 5) return d;
    if (d.length === 4) return d.padStart(5, '0');
    return '';
  }

  function normalizeZipList(zipField) {
    if (zipField == null || zipField === '') return [];
    const str = Array.isArray(zipField) ? zipField.join('\n') : String(zipField);
    const matches = str.match(/\d{4,5}/g);
    if (!matches) return [];
    return matches
      .map((m) => (m.length === 4 ? m.padStart(5, '0') : m))
      .filter((z) => z !== PLACEHOLDER_ZIP);
  }

  function dealerIsPreferred(p) {
    return p === true || p === 'true' || p === 1 || p === '1';
  }

  function dealerZipList(d) {
    return [
      ...normalizeZipList(d.service_zips),
      ...normalizeZipList(d.zip),
      ...normalizeZipList(d.zipcode),
    ];
  }

  global.dealersZipLookup = async function (customerZip) {
    const zip = normalizeDigitsToZip(customerZip);
    if (zip.length !== 5) return null;

    // Fetch from the same section endpoint the dealer locator modal uses
    const res = await fetch('/sections/dealer-data?section_id=dealer-data');
    if (!res.ok) throw new Error('Dealer data fetch failed');

    const text = await res.text();
    const jsonMatch = text.match(/\[[\s\S]*\]/);
    if (!jsonMatch) return null;

    const dealers = JSON.parse(jsonMatch[0]);

    const matches = dealers
      .map((d) => ({ ...d, _zipList: dealerZipList(d) }))
      .filter((d) => d._zipList.includes(zip))
      .sort((a, b) => {
        const ap = dealerIsPreferred(a.preferred);
        const bp = dealerIsPreferred(b.preferred);
        if (ap && !bp) return -1;
        if (!ap && bp) return 1;
        return String(a.title || '').localeCompare(String(b.title || ''));
      });

    if (!matches.length) return null;

    const best = matches[0];

    return {
      name:      best.title     || 'Unknown Dealer',
      dealer_id: best.dealer_id || '',
      email:     best.email     || '',
      phone:     best.phone     || '',
      zip:       zip,
      city:      best.city      || '',
      state:     best.state     || '',
      url:       best.url       || '',
      preferred: dealerIsPreferred(best.preferred),
    };
  };

})(window);